module.exports = __webpack_public_path__ + "img/img0.426ce9dd.jpg";